module.exports = __webpack_public_path__ + "img/ishii.3bb07ef7.jpg";